import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { customerRelate } from '@/api/yuntuSales/customerCenter'

const __default__ = { name: 'LbuRelationCustomer' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = __emit
const methods = [
  { label: '客户识别码', value: 'customerSerial' },
  { label: '客户代码', value: 'tmsCode' }
]
const handleSubmit = () => {
  formRef.value?.validate().then(() => {
    sure()
  })
}
const sure = async (relateConfirmFlag = false) => {
  loading.value = true
  try {
    const { type, customerSerial, tmsCode } = editForm.value
    const res = await customerRelate(
      {
        cosId: editForm.value.cosId,
        relateConfirmFlag,
        customerSerial: type === 'customerSerial' ? customerSerial : undefined,
        tmsCode: type === 'tmsCode' ? tmsCode : undefined
      },
      { custom: { errorMsg: false } }
    )
    if (res.code === 14030010) {
      DcConfirm.warning({
        title: '操作提示！',
        content: res.message,
        cancelText: '取消',
        okText: '继续',
        onOk() {
          sure(true)
        }
      })
    } else if (res.code === 200) {
      const content = type === 'customerSerial' ? customerSerial : tmsCode
      if (content) {
        DcMessage.success('关联成功')
      } else {
        DcMessage.success('取消关联成功')
      }
      emit('success')
      visible.value = false
    } else {
      DcMessage.error(res?.message)
    }
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}

const toggle = (row: any) => {
  editForm.value = {
    type: 'customerSerial',
    cosId: row.cosId,
    customerSerial: row.customerSerial,
    tmsCode: row.tmsCode,
    customerName: row.customerName || '--'
  }
  visible.value = true
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
    title: "关联客户",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            style: {"margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "customerName",
                label: "客户名称",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.value.customerName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.customerName) = $event)),
                    disabled: true
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "type",
                label: "关联客户"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: editForm.value.type,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.type) = $event)),
                    options: methods
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (editForm.value.type === 'customerSerial')
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    name: "customerSerial",
                    rules: [{ required: true, message: '请输入' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: editForm.value.customerSerial,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.customerSerial) = $event)),
                        placeholder: "请输入",
                        onInput: _cache[3] || (_cache[3] = (e) => editForm.value.customerSerial = e.target.value.toUpperCase())
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (editForm.value.type === 'tmsCode')
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 1,
                    name: "tmsCode",
                    rules: [{ required: true, message: '请输入' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: editForm.value.tmsCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((editForm.value.tmsCode) = $event)),
                        placeholder: "请输入",
                        onInput: _cache[5] || (_cache[5] = (e) => editForm.value.tmsCode = e.target.value.toUpperCase())
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})